export default __webpack_public_path__ + "static/media/instruments_light.c3d3bccf.png";